import { Type, type Static } from '@sinclair/typebox';
import { reactionSchema, ReactionWithParentPostSchema } from '../../shared/reaction/reaction.schema';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { CommentSchema, CommentWithParentPostSchema } from './comment.schema';

export const GetPostCommentsListResponseSchema = ListResponseSchema(CommentSchema);

export const GetPostCommentRepliesListResponseSchema = ListResponseSchema(CommentSchema);

export const AddPostCommentResponseSchema = CommentSchema;

export const ReplyToCommentResponseSchema = CommentSchema;

export const UpdatePostCommentResponseSchema = CommentSchema;

export const DeletePostCommentResponseSchema = Type.Null();

export const GetPostCommentReactionsListResponseSchema = ListResponseSchema(reactionSchema);

export const AddPostCommentReactionResponseSchema = Type.Object({
  object: Type.Literal('CommentReactionAdded'),
});

export const RemovePostCommentReactionResponseSchema = Type.Object({
  object: Type.Literal('CommentReactionRemoved'),
});

export const GetUserCommentsListResponseSchema = ListResponseSchema(CommentWithParentPostSchema);

export const GetUserReactionsListResponseSchema = ListResponseSchema(ReactionWithParentPostSchema);

export type GetPostCommentsListResponse = Static<typeof GetPostCommentsListResponseSchema>;
export type GetPostCommentRepliesListResponse = Static<typeof GetPostCommentRepliesListResponseSchema>;
export type AddPostCommentResponse = Static<typeof AddPostCommentResponseSchema>;
export type ReplyToCommentResponse = Static<typeof ReplyToCommentResponseSchema>;
export type UpdatePostCommentResponse = Static<typeof UpdatePostCommentResponseSchema>;
export type DeletePostCommentResponse = Static<typeof DeletePostCommentResponseSchema>;
export type GetPostCommentReactionsListResponse = Static<typeof GetPostCommentReactionsListResponseSchema>;
export type AddPostCommentReactionResponse = Static<typeof AddPostCommentReactionResponseSchema>;
export type RemovePostCommentReactionResponse = Static<typeof RemovePostCommentReactionResponseSchema>;
export type GetUserCommentsListResponse = Static<typeof GetUserCommentsListResponseSchema>;
export type GetUserReactionsListResponse = Static<typeof GetUserReactionsListResponseSchema>;
